import type { NavPalette } from "@/components/design-switcher/nav-palette";

export const c = {
  white: "#FFFFFF",
  cream: "#FEFCF8",
  warmGray: "#F5F0EA",
  foldShadow: "#E8E2D8",
  flamenco: "#F05260",
  flamencoLight: "#F47781",
  flamencoPale: "#FDE8EA",
  skyfall: "#84D5F7",
  skyfallLight: "#B0E4FB",
  skyfallPale: "#E4F5FD",
  mintleaf: "#4EB969",
  mintleafLight: "#7DD492",
  mintleafPale: "#E1F5E7",
  plumwood: "#842885",
  plumwoodLight: "#B666B7",
  plumwoodPale: "#F3E4F3",
  darkText: "#2A2035",
  medText: "#5C5066",
  lightText: "#8A8094",
};

export const nav: NavPalette = {
  surface: "rgba(254, 252, 248, 0.94)",
  surfaceHover: "rgba(245, 240, 234, 0.96)",
  border: "rgba(42, 32, 53, 0.22)",
  text: "#2A2035",
  textMuted: "rgba(92, 80, 102, 0.8)",
  activeBg: "rgba(253, 232, 234, 0.8)",
  activeText: "#F05260",
};
